export default __webpack_public_path__ + "static/media/nwc.36235664.png";